import React, { useState, useEffect } from "react";
import { createCertificate, fetchCertificates, updateCertificate, deleteCertificate } from "../../../../../services/experienceService";

const CertificateList = ({ profileId, initialCertificates }) => {
    const [certificates, setCertificates] = useState(initialCertificates || []);
    const [loading, setLoading] = useState(false);

    const [tempCertificate, setTempCertificate] = useState({
        title: "",
        issuing_organization: "",
        issue_date: "",
    });
    
    return (
        <>
            <div className="experience-block">
                {/* Header */}
                <div className="experience-header-row">
                    <h3 className="experience-title">Certificates</h3>
                </div>

                 {/* If NO certificates */}
                {certificates.length === 0 && (
                    <p className="no-certificates">No certificates listed.</p>
                )}

                {/* Certificate Cards */}
                {certificates.map((cert, index) => (
                    <div key={cert.id} className="experience-license-card">
                        <div className="license-field">
                            <span className="license-label">Title:</span> {cert.title}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Organization:</span>{" "}
                            {cert.issuing_organization}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Issued:</span> {cert.issue_date}
                        </div>
                    </div>
                ))}


            </div>
        </>

    );
};

export default CertificateList;